import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';

const MENSAGENS = [
  "Vai trabalhar galinha!! Confia em você, manda ver! 🐔",
  "Se você não fechar hoje, o porquinho vai chorar. Não deixa o porquinho chorar. 🐷",
  "Bom dia! Hoje é dia de bater meta ou de dar desculpa. Escolha sabiamente. 💅",
  "Você sabia que cada 'não' te aproxima de um 'sim'? Então vai lá levar mais uns 'não'. 😂",
  "Café na mão, meta na mente, leads no papo. Vaaai! ☕",
  "Essa semana tá boa demais pra você ficar parado. Corre! 🏃",
  "Lembra que o salário não vai aparecer sozinho, né? Vai lá! 💰",
  "Hoje é dia de ser VENDEDOR. Não de ficar olhando pro CRM achando bonito. 😂",
  "A meta não se bate pensando. Vai fazer acontecer! 🔥",
  "Você é incrível. Mas o cliente não sabe disso ainda. Vai contar pra ele! 🌟",
  "Sabia que estatisticamente, quem abre o CRM de manhã fecha mais? Abre logo! 📊",
  "Hoje seu lead tá esperando por você. Não deixa ele na mão! 📞",
  "Meta: 100%. Você agora: nem sei. Diferença: esforço. Bora! 💪",
  "Deus abençoe seu dia e seus fechamentos. Amém! 🙏",
  "Não sei você, mas eu tô com fome de resultado hoje! 🍽️",
  "Quantos 'oi tudo bem?' você já mandou hoje? Mais um então! 😄",
  "Você não nasceu pra ser mediano. Vai ser extraordinário! ✨",
  "Sua meta tá olhando pra você com aquele olhar de 'e aí?'. Responde! 👀",
  "Follow-up é amor. Segue o lead com carinho! 💌",
  "Hoje tem reunião? Arrasaaaa! Sem reunião? Agenda uma! 📅",
  "Pior do que perder um lead é nem ter tentado. Vai tentar! 🎯",
  "Você lembra que tem tarefas pendentes né? Vai lá! 📋",
  "O sucesso é feito de pequenas ações repetidas todo dia. Faz a sua! 🏆",
  "Hoje o universo conspirou a seu favor. Mas você ainda tem que trabalhar. 😂",
  "Qual é a desculpa de hoje? Nenhuma? Ótimo, vai trabalhar! 🚀",
  "Cada lead é uma oportunidade. Cada oportunidade é dinheiro. Cada dinheiro é porquinho cheio. 🐷💰",
  "Você sabia que 80% dos fechamentos acontecem após o 5º follow-up? Vai lá no 5º! 📲",
  "Sorria! O cliente sente sua energia mesmo por mensagem. 😊",
  "Mais uma semana de oportunidades. Não desperdiça não! 🌈",
  "Hoje é dia de você superar suas próprias expectativas. Vai nessa! 💥",
  "A Vuli não para. E você? Vai lá! 🏢",
  "Cada tarefa concluída é uma vitória. Vai atrás das suas vitórias! 🥇",
  "Tá com preguiça? Pensa no porquinho vazio. Agora foi? 🐷",
  "Confio em você mais do que você confia em você mesmo. Vai lá! 🤝",
  "Se o lead não fechou ontem, fecha hoje. Se não hoje, amanhã. Mas fecha! 🔒",
  "Você é a melhor versão de si mesmo quando está no CRM. FICA AQUI! 😂",
  "Resultado não cai do céu... cai do follow-up. Manda mensagem! ☁️",
  "Hoje você vai arrasar. Eu sinto nos meus bytes. 🤖✨",
  "Não esquece: cliente feliz indica. Cliente indicado fecha mais fácil. Faz feliz! 😃",
  "Vai com Deus e com a meta! 🙏🎯",
  "O mercado tá bravo, mas você é mais bravo ainda. Vai! 😤",
  "Quantas ligações você vai fazer hoje? Mais que ontem! 📞",
  "A diferença entre campeão e o resto é que o campeão não desiste. Vai campeão! 🏆",
  "Hoje tem chance de ser o melhor dia do mês. Aproveita! 🌟",
  "Dorme pensando em meta, acorda batendo meta. Você dormiu? Então vai bater! 😴➡️💰",
  "Não é sobre ser perfeito, é sobre ser consistente. Consistência hoje! ✅",
  "Você foi feito pra voar, não pra ficar olhando o pássaro voar. DECOLA! 🦅",
  "Atitude de ganhador, postura de profissional, resultado de campeão. VAI! 🌟",
  "O lead de hoje é o cliente de amanhã. Trata bem! 🤝",
  "Foco. Força. Fechamento. FFF do dia! 💪",
];


const prioridadeCor = { alta: '#E05454', media: '#C9A84C', baixa: '#5BAD8F' };



export default function Dashboard() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const perfil = usuario?.perfil || 'sdr';
  const nome = usuario?.nome || 'Colaborador';
  const isGestorOuAdmin = perfil === 'admin' || perfil === 'gestor';

  const hoje = new Date();
  const hojeStr = hoje.toISOString().split('T')[0];
  const diaDoAno = Math.floor((hoje - new Date(hoje.getFullYear(), 0, 0)) / 86400000);
  const mensagemHoje = MENSAGENS[diaDoAno % MENSAGENS.length];
  const dataFormatada = hoje.toLocaleDateString('pt-BR', { weekday:'long', day:'numeric', month:'long' });

  const chavePresente = `presente_${hoje.toDateString()}`;
  const [presenteAberto, setPresenteAberto] = useState(false);
  const [presenteVisto, setPresenteVisto] = useState(() => {
    try { return localStorage.getItem(chavePresente) === 'sim'; } catch { return false; }
  });
  const [notifAberta, setNotifAberta] = useState(false);

  const [kpiValores, setKpiValores] = useState({ leads: 0, callsHoje: 0, metasPct: 0, atrasadas: 0 });
  const [callsHoje, setCallsHoje] = useState([]);
  const [tarefasSemana, setTarefasSemana] = useState([]);
  const [acoesAtrasadas, setAcoesAtrasadas] = useState([]);
  const [metasResumo, setMetasResumo] = useState([]);
  const [notificacoes, setNotificacoes] = useState(() => {
    try {
      const salvas = localStorage.getItem('notif_vuli');
      return salvas ? JSON.parse(salvas) : [];
    } catch { return []; }
  });

  useEffect(() => { carregarDados(); }, []);

  async function carregarDados() {
    const fimSemana = new Date(hoje);
    fimSemana.setDate(hoje.getDate() + 7);
    const fimSemanaStr = fimSemana.toISOString().split('T')[0];

    const [
      { count: totalLeads },
      { data: callsData },
      { data: atrasadasData },
      { data: tarefasData },
      { data: metasData },
    ] = await Promise.all([
      supabase.from('crm_leads').select('*', { count: 'exact', head: true }),
      supabase.from('agenda').select('*').eq('data', hojeStr).in('tipo', ['call','reuniao']).eq('status', 'Agendado'),
      supabase.from('agenda').select('id, titulo, data, tipo').lt('data', hojeStr).eq('status', 'Agendado'),
      supabase.from('tarefas').select('id, titulo, prazo, prioridade').lte('prazo', fimSemanaStr).neq('status', 'Concluído').order('prazo'),
      supabase.from('metas').select('id, nome, meta, atual, projeto').order('created_at').limit(5),
    ]);

    setCallsHoje(callsData || []);
    setAcoesAtrasadas(atrasadasData || []);
    setTarefasSemana((tarefasData || []).slice(0, 5));
    setMetasResumo(metasData || []);

    const metasBatidas = (metasData || []).filter(m => m.atual >= m.meta).length;
    const metasPct = metasData?.length > 0 ? Math.round((metasBatidas / metasData.length) * 100) : 0;

    setKpiValores({
      leads: totalLeads || 0,
      callsHoje: callsData?.length || 0,
      metasPct,
      atrasadas: atrasadasData?.length || 0,
    });
  }

  const KPI_DINAMICO = {
    admin: [
      { label: 'Leads ativos', valor: kpiValores.leads, sub: 'Total no sistema', cor: 'kpi-lilac', link: '/leads' },
      { label: 'Calls/reuniões hoje', valor: kpiValores.callsHoje, sub: 'Agendadas', cor: 'kpi-gold', link: '/agenda' },
      { label: 'Metas cumpridas', valor: `${kpiValores.metasPct}%`, sub: 'Das metas cadastradas', cor: 'kpi-green', link: '/metas' },
      { label: 'Ações atrasadas', valor: kpiValores.atrasadas, sub: kpiValores.atrasadas === 0 ? 'Tudo em dia!' : 'Na agenda', cor: 'kpi-red', link: '/agenda' },
    ],
    gestor: [
      { label: 'Leads ativos', valor: kpiValores.leads, sub: 'Total no sistema', cor: 'kpi-lilac', link: '/leads' },
      { label: 'Calls/reuniões hoje', valor: kpiValores.callsHoje, sub: 'Agendadas', cor: 'kpi-gold', link: '/agenda' },
      { label: 'Metas cumpridas', valor: `${kpiValores.metasPct}%`, sub: 'Das metas cadastradas', cor: 'kpi-green', link: '/metas' },
      { label: 'Ações atrasadas', valor: kpiValores.atrasadas, sub: kpiValores.atrasadas === 0 ? 'Tudo em dia!' : 'Na agenda', cor: 'kpi-red', link: '/agenda' },
    ],
    sdr: [
      { label: 'Calls hoje', valor: kpiValores.callsHoje, sub: 'Agendadas', cor: 'kpi-gold', link: '/agenda' },
      { label: 'Ações atrasadas', valor: kpiValores.atrasadas, sub: kpiValores.atrasadas === 0 ? 'Tudo em dia!' : 'Verificar agenda', cor: 'kpi-red', link: '/agenda' },
      { label: 'Leads cadastrados', valor: kpiValores.leads, sub: 'Total', cor: 'kpi-green', link: '/leads' },
    ],
    closer: [
      { label: 'Calls hoje', valor: kpiValores.callsHoje, sub: 'Agendadas', cor: 'kpi-gold', link: '/agenda' },
      { label: 'Ações atrasadas', valor: kpiValores.atrasadas, sub: kpiValores.atrasadas === 0 ? 'Tudo em dia!' : 'Verificar agenda', cor: 'kpi-red', link: '/agenda' },
      { label: 'Metas cumpridas', valor: `${kpiValores.metasPct}%`, sub: 'Das metas cadastradas', cor: 'kpi-green', link: '/metas' },
      { label: 'Leads ativos', valor: kpiValores.leads, sub: 'Total', cor: 'kpi-lilac', link: '/leads' },
    ],
  };

  const kpis = KPI_DINAMICO[perfil] || KPI_DINAMICO.sdr;
  const naoLidas = notificacoes.filter(n => !n.lida).length;

  function marcarLida(id) {
    const atualizadas = notificacoes.map(n => n.id === id ? { ...n, lida: true } : n);
    setNotificacoes(atualizadas);
    try { localStorage.setItem('notif_vuli', JSON.stringify(atualizadas)); } catch {}
  }

  function abrirPresente() {
    setPresenteAberto(true);
    setPresenteVisto(true);
    try { localStorage.setItem(chavePresente, 'sim'); } catch {}
  }

  return (
    <div style={{ position: 'relative' }}>

      {/* Header do dia */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 }}>
        <div>
          <div style={{ fontSize:12, color:'var(--gray-400)', marginBottom:4, textTransform:'capitalize' }}>{dataFormatada}</div>
          <h2 style={{ margin:0, fontSize:20, color:'var(--text-primary)', fontWeight:700 }}>
            Bom dia, {nome.split(' ')[0]}!
          </h2>
        </div>
        <div style={{ display:'flex', gap:12, alignItems:'center' }}>
          {/* Sino de notificações */}
          <div style={{ position:'relative' }}>
            <button onClick={() => setNotifAberta(!notifAberta)}
              style={{ background:'var(--bg-secondary)', border:'1px solid var(--border)', borderRadius:8, padding:'8px 12px', cursor:'pointer', display:'flex', alignItems:'center', gap:6, color:'var(--text-secondary)', fontSize:13 }}>
              🔔
              {naoLidas > 0 && (
                <span style={{ background:'#E05454', color:'white', borderRadius:20, padding:'1px 6px', fontSize:10, fontWeight:700 }}>{naoLidas}</span>
              )}
            </button>

            {/* Painel de notificações */}
            {notifAberta && (
              <div style={{ position:'absolute', right:0, top:44, width:320, background:'#ffffff', border:'1px solid var(--border)', borderRadius:10, boxShadow:'0 8px 24px rgba(0,0,0,0.18)', zIndex:200 }}>
                <div style={{ padding:'14px 16px', borderBottom:'1px solid var(--border)', fontWeight:700, fontSize:14, color:'var(--text-primary)' }}>
                  Notificações
                </div>
                {notificacoes.map(n => (
                  <div key={n.id} onClick={() => marcarLida(n.id)}
                    style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)', cursor:'pointer', background: n.lida ? 'transparent' : 'var(--bg-secondary)', display:'flex', gap:10, alignItems:'flex-start' }}>
                    <span style={{ fontSize:16 }}>{n.tipo === 'alerta' ? '⚠️' : n.tipo === 'tarefa' ? '📋' : 'ℹ️'}</span>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, color:'var(--text-primary)', lineHeight:1.4 }}>{n.texto}</div>
                      {!n.lida && <div style={{ fontSize:11, color:'var(--purple)', marginTop:3, fontWeight:600 }}>Toque para marcar como lida</div>}
                    </div>
                  </div>
                ))}
                {notificacoes.every(n => n.lida) && (
                  <div style={{ padding:20, textAlign:'center', color:'var(--gray-400)', fontSize:13 }}>Tudo em dia! ✅</div>
                )}
              </div>
            )}
          </div>

          {/* Presente do dia */}
          {!presenteVisto && (
            <button onClick={abrirPresente}
              style={{ background:'linear-gradient(135deg, #6B2FA0, #C9A84C)', border:'none', borderRadius:8, padding:'8px 16px', cursor:'pointer', color:'white', fontWeight:700, fontSize:13, animation:'pulse 2s infinite' }}>
              🎁 Surpresa do dia!
            </button>
          )}
        </div>
      </div>

      {/* Modal presente */}
      {presenteAberto && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div className="card" style={{ width:420, padding:40, textAlign:'center' }}>
            <div style={{ fontSize:48, marginBottom:16 }}>🎁</div>
            <div style={{ fontSize:16, color:'var(--text-primary)', lineHeight:1.6, fontWeight:500, marginBottom:24 }}>
              {mensagemHoje}
            </div>
            <button onClick={() => setPresenteAberto(false)}
              style={{ background:'var(--purple)', color:'white', border:'none', padding:'12px 32px', borderRadius:8, fontWeight:700, cursor:'pointer', fontSize:14 }}>
              Arrasaaaaa! 💪
            </button>
          </div>
        </div>
      )}

      {/* KPIs clicáveis */}
      <div className="kpi-grid" style={{ marginBottom:20 }}>
        {kpis.map((k, i) => (
          <div key={i} className={`kpi-card ${k.cor}`} onClick={() => navigate(k.link)}
            style={{ cursor:'pointer', transition:'transform 0.15s', userSelect:'none' }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
            <div className="kpi-label">{k.label}</div>
            <div className="kpi-value">{k.valor}</div>
            <div className="kpi-sub">{k.sub}</div>
          </div>
        ))}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:14 }}>
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>

          {/* Tarefas da semana — só admin e gestor */}
          {isGestorOuAdmin && (
            <div className="card">
              <div className="card-header">
                <div className="card-title">Tarefas da semana</div>
                <button className="btn btn-outline" style={{ height:28, fontSize:11 }} onClick={() => navigate('/projetos')}>
                  Ver projetos
                </button>
              </div>
              {tarefasSemana.length === 0 && (
                <div style={{ padding:'20px 16px', textAlign:'center', color:'var(--gray-400)', fontSize:13 }}>Nenhuma tarefa pendente esta semana.</div>
              )}
              {tarefasSemana.map((t) => (
                <div key={t.id} onClick={() => navigate('/projetos')}
                  style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 16px', borderBottom:'0.5px solid #f5f0fa', cursor:'pointer' }}>
                  <div style={{ width:8, height:8, borderRadius:'50%', background:prioridadeCor[t.prioridade]||'#ccc', flexShrink:0 }} />
                  <div style={{ flex:1, fontSize:13, color:'var(--gray-800)' }}>{t.titulo}</div>
                  <div style={{ fontSize:11, fontWeight:600, color: t.prioridade === 'alta' ? '#E05454' : 'var(--gray-400)' }}>{t.prazo}</div>
                </div>
              ))}
            </div>
          )}

          {/* Calls do dia */}
          <div className="card">
            <div className="card-header">
              <div className="card-title">Calls e reuniões hoje</div>
              <button className="btn btn-outline" style={{ height:28, fontSize:11 }} onClick={() => navigate('/agenda')}>
                Ver agenda
              </button>
            </div>
            {callsHoje.length === 0 ? (
              <div style={{ padding:'20px 16px', textAlign:'center', color:'var(--gray-400)', fontSize:13 }}>
                Nenhuma call ou reunião agendada para hoje.
                <br />
                <button onClick={() => navigate('/agenda')}
                  style={{ marginTop:10, background:'var(--purple)', color:'white', border:'none', padding:'7px 16px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600 }}>
                  + Agendar
                </button>
              </div>
            ) : callsHoje.map(e => (
              <div key={e.id} onClick={() => navigate('/agenda')}
                style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 16px', borderBottom:'0.5px solid #f5f0fa', cursor:'pointer' }}>
                <span style={{ fontSize:16 }}>{e.tipo === 'call' ? '📞' : '👥'}</span>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:13, color:'var(--text-primary)', fontWeight:500 }}>{e.titulo}</div>
                  <div style={{ fontSize:11, color:'var(--gray-400)' }}>{e.hora}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Ações atrasadas */}
          <div className="card">
            <div className="card-header">
              <div className="card-title">Ações atrasadas</div>
            </div>
            {acoesAtrasadas.length === 0 ? (
              <div style={{ padding:'20px 16px', textAlign:'center', color:'var(--gray-400)', fontSize:13 }}>
                Nenhuma ação atrasada. Tudo em dia! ✅
              </div>
            ) : acoesAtrasadas.slice(0, 5).map(a => (
              <div key={a.id} onClick={() => navigate('/agenda')}
                style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 16px', borderBottom:'0.5px solid #f5f0fa', cursor:'pointer' }}>
                <span style={{ color:'#E05454', fontSize:14 }}>⚠️</span>
                <div style={{ flex:1, fontSize:13, color:'var(--text-primary)' }}>{a.titulo}</div>
                <div style={{ fontSize:11, color:'#E05454', fontWeight:600 }}>{a.data}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>

          {/* Metas do mês */}
          <div className="card">
            <div className="card-header">
              <div className="card-title">Metas do mês</div>
              <button className="btn btn-outline" style={{ height:28, fontSize:11 }} onClick={() => navigate('/metas')}>
                Ver metas
              </button>
            </div>
            {metasResumo.length === 0 ? (
              <div style={{ padding:'20px 14px', textAlign:'center', color:'var(--gray-400)', fontSize:13 }}>
                Nenhuma meta cadastrada ainda.
                <br />
                <button onClick={() => navigate('/metas')}
                  style={{ marginTop:10, background:'var(--gold)', color:'#1a0a00', border:'none', padding:'7px 16px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600 }}>
                  + Criar meta
                </button>
              </div>
            ) : metasResumo.map(m => {
              const pct = m.meta > 0 ? Math.min(100, Math.round((m.atual / m.meta) * 100)) : 0;
              return (
                <div key={m.id} style={{ padding:'10px 16px', borderBottom:'0.5px solid #f5f0fa' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4 }}>
                    <span style={{ fontSize:12, color:'var(--text-primary)', fontWeight:500 }}>{m.nome}</span>
                    <span style={{ fontSize:11, fontWeight:700, color: pct >= 100 ? '#16a34a' : pct >= 70 ? '#C9A84C' : '#E05454' }}>{pct}%</span>
                  </div>
                  <div style={{ height:4, background:'var(--border)', borderRadius:4 }}>
                    <div style={{ width:`${pct}%`, height:'100%', background: pct >= 100 ? '#16a34a' : pct >= 70 ? '#C9A84C' : 'var(--purple)', borderRadius:4, transition:'width 0.3s' }} />
                  </div>
                </div>
              );
            })}
          </div>

          {/* Acesso rápido */}
          <div className="card" style={{ padding:16 }}>
            <div style={{ fontWeight:700, fontSize:13, color:'var(--text-primary)', marginBottom:12 }}>Acesso rápido</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              {[
                { label:'Novo Lead', icon:'👤', link:'/leads', cor:'var(--purple)' },
                { label:'Agenda', icon:'📅', link:'/agenda', cor:'#4A90D9' },
                { label:'CRM', icon:'📊', link:'/crm', cor:'#C9A84C' },
                ...(isGestorOuAdmin ? [
                  { label:'Relatórios', icon:'📈', link:'/relatorios', cor:'#5BAD8F' },
                  { label:'Projetos', icon:'📁', link:'/projetos', cor:'#9B7FD4' },
                  { label:'Financeiro', icon:'💰', link:'/financeiro', cor:'#D4789B' },
                ] : []),
              ].map((a, i) => (
                <button key={i} onClick={() => navigate(a.link)}
                  style={{ padding:'12px 8px', borderRadius:8, border:`1px solid var(--border)`, background:'var(--bg-secondary)', cursor:'pointer', textAlign:'center', transition:'all 0.15s' }}
                  onMouseEnter={e => { e.currentTarget.style.background = a.cor; e.currentTarget.style.color = 'white'; e.currentTarget.style.borderColor = a.cor; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg-secondary)'; e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.borderColor = 'var(--border)'; }}>
                  <div style={{ fontSize:20, marginBottom:4 }}>{a.icon}</div>
                  <div style={{ fontSize:11, fontWeight:600 }}>{a.label}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
